const actions = {
  SET_STATE: 'promotion/SET_STATE',
  SHOW_PROMOTION: 'promotion/SHOW_PROMOTION',
  UPDATE_PROMOTION_STATUS: 'promotion/UPDATE_PROMOTION_STATUS',
  CREATE_PROMOTION: 'promotion/CREATE_PROMOTION',
}

export default actions
